export const heroImages = {
        AF: 'images/covers/hero/afghanistan.webp',
        AM: 'images/covers/hero/armenia.webp',
        AU: 'images/covers/hero/australia.webp',
        AZ: 'images/covers/hero/azerbaijan.webp',
        BY: 'images/covers/hero/belarus.webp',
        BR: 'images/covers/hero/brazil.webp',
        CA: 'images/covers/hero/canada.webp',
        CN: 'images/covers/hero/china.webp',
        CU: 'images/covers/hero/cuba.webp',
        EG: 'images/covers/hero/egypt.webp',
        FR: 'images/covers/hero/france.webp',
        GE: 'images/covers/hero/georgia.webp',
        JP: 'images/covers/hero/japan.webp',
        LS: 'images/covers/hero/lesotho.webp',
        MG: 'images/covers/hero/madagascar.webp',
        MX: 'images/covers/hero/mexico.webp',
        MA: 'images/covers/hero/morocco.webp',
        NA: 'images/covers/hero/namibia.webp',
        NZ: 'images/covers/hero/newzealand.webp',
        KP: 'images/covers/hero/northkorea.webp',
        NO: 'images/covers/hero/norway.webp',
        RU: 'images/covers/hero/russia.webp',
        SG: 'images/covers/hero/singapore.webp',
        AE: 'images/covers/hero/uae.webp',
        GB: 'images/covers/hero/unitedkingdom.webp',
        US: 'images/covers/hero/usa.webp',
        VA: 'images/covers/hero/vatican.webp',
        YE: 'images/covers/hero/yemen.webp',
        ZM: 'images/covers/hero/zambia.webp',
        SO: 'images/covers/hero/somalia.webp',
        SY: 'images/covers/hero/syria.webp',
        BG: 'images/covers/hero/bulgaria.webp',
        CO: 'images/covers/hero/colombia.webp',
        EC: 'images/covers/hero/ecuador.webp',
        IN: 'images/covers/hero/india.webp',
        IR: 'images/covers/hero/iran.webp',
        IL: 'images/covers/hero/israel.webp',
        IT: 'images/covers/hero/italy.webp',
        ES: 'images/covers/hero/spain.webp',
        LK: 'images/covers/hero/srilanka.webp',
        TR: 'images/covers/hero/turkey.webp',
        UA: 'images/covers/hero/ukraine.webp',
        UZ: 'images/covers/hero/uzbekistan.webp',
        DE: 'images/covers/hero/germany.webp',
        GI: 'images/covers/hero/gibraltar.webp',
        ZA: 'images/covers/hero/southafrica.webp',
        KR: 'images/covers/hero/southkorea.webp',
        VE: 'images/covers/hero/venezuela.webp',
        BO: 'images/covers/hero/bolivia.webp',
        PE: 'images/covers/hero/peru.webp',
        LB: 'images/covers/hero/lebanon.webp',
        PT: 'images/covers/hero/portugal.webp',
};


export const groupImages = {
    north_africa: '/images/covers/groups/north_africa.webp',
    wild_africa: '/images/covers/groups/wild_africa.webp',
    west_africa: '/images/covers/groups/west_africa.webp',
    african_landscapes: '/images/covers/groups/african_landscapes.webp',
    central_africa: '/images/covers/groups/central_africa.webp',
    central_america: '/images/covers/groups/central_america.webp',
    glaciers: '/images/covers/groups/glaciers.webp',
    mediterranian: '/images/covers/groups/mediterranian.webp',
    alpins_pirreneans: '/images/covers/groups/alpins_pirreneans.webp',
    eastern_europe: '/images/covers/groups/eastern_europe.webp',
    europe: '/images/covers/groups/europe.webp',
    karelia: '/images/covers/groups/karelia.webp',
    baltic: '/images/covers/groups/baltic.webp',
    polynesia: '/images/covers/groups/polynesia.webp',
    caribbean: '/images/covers/groups/caribbean.webp',
    tropical_islands: '/images/covers/groups/tropical_islands.webp',
    arabian: '/images/covers/groups/arabian.webp',
    himalayan: '/images/covers/groups/himalayan.webp',
    muslim_asia: '/images/covers/groups/muslim_asia.webp',
    buddha_asia: '/images/covers/groups/buddha_asia.webp',
    island_life: '/images/covers/groups/island_life.webp',
    cold_islands: '/images/covers/groups/cold_islands.webp',
    greenland_iceland: '/images/covers/groups/greenland_iceland.webp',
    cliffs: '/images/covers/groups/cliffs.webp',
    steppe: '/images/covers/groups/steppe.webp',
    east_asian_hubs: '/images/covers/groups/east_asian_hubs.webp',
};


// export const defaultHeroImage